// JavaScript for LP Exhibition section
import { gsap } from 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/+esm';
import { ScrollTrigger } from 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/ScrollTrigger/+esm';

gsap.registerPlugin(ScrollTrigger);

document.body.classList.add('lp-exhibition');

// ビューポート高さを固定値で保持（SPのアドレスバー出し入れで高さが変わらないように）
// 横幅が変わったとき（回転など）だけ更新する
let _vhW = window.innerWidth;
const setVh = () => {
  document.documentElement.style.setProperty('--lp-vh', `${window.innerHeight * 0.01}px`);
};
setVh();
window.addEventListener('resize', () => {
  if (window.innerWidth === _vhW) return;
  _vhW = window.innerWidth;
  setVh();
});

let _w = window.innerWidth;
let _move = _w*0.2;
let _move2 = _move * -1; 
window.addEventListener('resize', () => {
  _w = window.innerWidth;
  _move = _w*0.2;
  _move2 = _move * -1;
});

function marquee_func() {
  const marquee = document.querySelectorAll('.marquee');
  if (marquee.length > 0) {
    marquee.forEach((marqueeItem) => {
      const marqueeTrack = marqueeItem.querySelector('.marquee__track');
      marqueeItem.style.transformOrigin = 'top';
      if (marqueeTrack) {
        const tl = gsap.timeline({
          defaults: { duration: 0.8, ease: 'power2.out' },
          delay: 0.8,
          scrollTrigger: {
            trigger: marqueeItem,
            start: 'top 80%',
          }
        });
        tl.fromTo(marqueeItem,
          { scaleY: 0 }, 
          { scaleY: 1, duration: 0.4 }
        )
        .fromTo(marqueeTrack,
          { scaleY: 0, rotationX: -360 },
          { scaleY: 1, rotationX: 0, }
        );
      }
    });
  }
}
marquee_func();

function hero_func() {
  gsap.from('.hero_el', {
    opacity: 0,
    filter: 'blur(10px)',
    // scaleY: 0,
    // rotationX: -360,
    duration: 1.2,
    delay: 0.5,
    ease: 'power2.out',
    stagger: 0.4,
  });
}
hero_func();

function blcImg_func() {
  const directions = [
    { y: _move, opacity: 0 },
    { x: _move2, opacity: 0 },
    { x: _move, opacity: 0 },
    { y: _move2, opacity: 0 },
  ];
  document.querySelectorAll('.blcimgel').forEach((blc) => {
    const offset = blc.classList.contains('even') ? 2 : 0;
    blc.querySelectorAll('.el').forEach((img, index) => {
      const trigger = blc.classList.contains('type_c') ? img : blc;
      gsap.from(img, {
        ...directions[(offset + index) % 4],
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: trigger,
          start: 'top 80%',
        }
      });
    });
  });
}
blcImg_func();

function outro_func() {
  const directions = [
    { x: _move2, opacity: 0 },
    { x: _move, opacity: 0 },
  ];
  const outro = document.querySelector('.outro');
  if (!outro) return;
  outro.querySelectorAll('.outro_img').forEach((img, index) => {
    gsap.from(img, {
      ...directions[index % 3],
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: outro,
        start: 'top 80%',
      }
    });
  });

  const outro__full = outro.querySelector('.outro__full');
  const outro__full_img = outro__full.querySelector('.img');
  const isSP = window.matchMedia('(max-width: 699px)').matches;
  const outroElPos = isSP ? '-=0.4' : '+=0';
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: outro,
      start: 'top 80%',
    }
  });
  tl.fromTo(outro__full_img,
    { y: _move, opacity: 0 },
    { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }
  )
  .fromTo('.outro_el', 
    { opacity: 0, filter: 'blur(10px)' },
    { opacity: 1, filter: 'blur(0px)',
      duration: 0.8,
      ease: 'power2.out',
      stagger: 0.4,
    }, outroElPos
  );
}
outro_func();

